"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.LOADED_MEMBERS = void 0;
exports.getMember = getMember;
exports.getMembersByIds = getMembersByIds;
exports.getOrganisationMembers = getOrganisationMembers;
exports.loadMembers = loadMembers;
exports.loadMembersByIds = loadMembersByIds;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _utils = require("./utils");
var _createMappedReducer;
/**
 * Any actions dealing with fetching data for / updating the 'members'
 * key in state, and their associated reducers, should be handled
 * in this file.
 */
var defaultState = {
  orgs: {},
  entities: {}
};
var LOADING_MEMBERS = 'MEMBERS/LOADING_MEMBERS';
var LOADED_MEMBERS = exports.LOADED_MEMBERS = 'MEMBERS/LOADED_MEMBERS';
var MEMBERS_NOT_FOUND = 'MEMBERS/MEMBERS_NOT_FOUND';
var DEFAULT_MEMBER = (0, _freeze["default"])((0, _objectSpread2["default"])({}, _utils.DEFAULT_LOADABLE));
var DEFAULT_ORG = (0, _freeze["default"])({
  members: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
    memberIds: []
  })
});
var memberTypes = ['OFST', 'OFSA', 'CORP', 'CORSA'];

/**
 * Walk through the list of members and mark those indicated in memberIds as
 * not found if they are still flagged as loading, or are not present at all.
 *
 * This is triggered after loading members for an organisation to identify those
 * that were asked for but were not present in result set (e.g. when an invalid
 * id is given in a member page url).
 *
 * @param {Object} members A list of members keyed by ID.
 * @param {Array} memberIds The IDs of the members to mark not found.
 *
 * @return {Object} The modified list of members if changes were made, otherwise
 *                  the original members object (safe for reducers).
 */
function markNotFoundPage(members, memberIds) {
  var dirty = false;
  var next = (0, _objectSpread2["default"])({}, members);
  (0, _forEach["default"])(memberIds).call(memberIds, function (id) {
    var member = members[id];
    if (member && !member.loading) {
      return;
    }
    dirty = true;
    next[id] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_MEMBER), member), {}, {
      loading: false,
      loaded: true,
      notFound: true
    });
  });
  return dirty ? next : members;
}

/**
 * Records that we're loading members for the given organisations.  This also
 * flags specifically requested members as loading.
 *
 * @param {Object} state The members slice of the state.
 * @param {Object} action The action object.
 *
 * @returns {Object} The new member slice.
 */
function reduceLoadingMembers(state, action) {
  var _context, _context2;
  var orgs = (0, _reduce["default"])(_context = action.organisationIds).call(_context, function (result, id) {
    result[id] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), state.orgs[id]), {}, {
      members: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG.members), {}, {
        loading: true
      })
    });
    return result;
  }, {});

  // Flag members as loading if they're not already loaded
  var members = (0, _reduce["default"])(_context2 = action.memberIds).call(_context2, function (result, memberId) {
    if (state.entities[memberId]) {
      return result;
    }

    // eslint-disable-next-line no-param-reassign
    result[memberId] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_MEMBER), {}, {
      loading: true,
      memberId: memberId
    });
    return result;
  }, {});
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
    orgs: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state.orgs), orgs),
    entities: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state.entities), members)
  });
}

/**
 * Record that members have been loaded.
 *
 * @param {Object} state The members slice of the state.
 * @param {Object} action The action object.
 *
 * @returns {Object} The new member slice.
 */
function reduceLoadedMembers(state, action) {
  var _context3, _context4, _context6;
  var orgs = (0, _reduce["default"])(_context3 = action.organisationIds).call(_context3, function (result, id) {
    result[id] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_ORG), state.orgs[id]), {}, {
      members: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state.orgs[id].members), {}, {
        loading: false,
        loaded: true,
        error: action.error,
        memberIds: []
      })
    });
    return result;
  }, {});
  var idType = action.orgsAreTeams ? 'teamIds' : 'organisationIds';

  // Push member IDs into each of their applicable organisations
  (0, _forEach["default"])(_context4 = action.members).call(_context4, function (member) {
    var _context5;
    (0, _forEach["default"])(_context5 = member[idType]).call(_context5, function (orgId) {
      if (!orgs[orgId]) {
        return;
      }
      orgs[orgId].members.memberIds.push(member.memberId);
    });
  });
  var members = (0, _reduce["default"])(_context6 = action.members).call(_context6, function (result, member) {
    result[member.memberId] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.DEFAULT_LOADABLE), member), {}, {
      loading: false,
      loaded: true,
      error: action.error
    });
    return result;
  }, {});
  var next = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
    orgs: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state.orgs), orgs),
    entities: markNotFoundPage((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state.entities), members), action.memberIds)
  });
  return next;
}

/**
 * Check for requested members not being found.  This is dispatched when member
 * loading is requested but all organisations have already loaded their members,
 * so that the requested members can be flagged as not found.
 *
 * @param {Object} state The members slice of the state.
 * @param {Object} action The action object.
 *
 * @returns {Object} The new member slice.
 */
function reduceMembersNotFoundPage(state, action) {
  var entities = markNotFoundPage(state.entities, action.memberIds);

  // Only return modified state if the entities have been changed
  return entities === state.entities ? state : (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state), {}, {
    entities: entities
  });
}

/**
 * The main reducer, dispatches to sub reducers as indicated in the action map.
 *
 * @function
 *
 * @param {Object} state The content slice of the state.
 * @param {Object} action The action object.
 *
 * @returns {Object} The new members slice.
 */
var reducer = (0, _utils.createMappedReducer)((_createMappedReducer = {}, _createMappedReducer[LOADING_MEMBERS] = reduceLoadingMembers, _createMappedReducer[LOADED_MEMBERS] = reduceLoadedMembers, _createMappedReducer[MEMBERS_NOT_FOUND] = reduceMembersNotFoundPage, _createMappedReducer), defaultState);
var _default = exports["default"] = reducer;
function getMember(state, memberId) {
  return state.entities[memberId] || (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, DEFAULT_MEMBER), {}, {
    memberId: memberId
  });
}
var pick = function pick(obj, ids) {
  return (0, _reduce["default"])(ids).call(ids, function (acc, id) {
    acc.push(obj[id]);
    return acc;
  }, []);
};

/**
 * Retrieve all members for the indicated organisation ids.
 *
 * @param {Object} state The members slice of the state.
 * @param {Array} organisationIds A list of the organisations to get members for.
 *
 * @returns {Object} Result object containing loaded, error and entities.  Only
 *                   the first error (if any) is returned.
 */
function getOrganisationMembers(state, organisationIds) {
  var _context7;
  var orgs = state.orgs;
  var memberIds = (0, _reduce["default"])(_context7 = (0, _map["default"])(organisationIds).call(organisationIds, function (id) {
    return orgs[id] ? orgs[id].members.memberIds : [];
  })).call(_context7, function (result, ids) {
    return (0, _concat["default"])(result).call(result, ids);
  }, []);
  var loaded = !!(0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result && orgs[id] && orgs[id].members.loaded;
  }, true);
  var loading = !!(0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result || orgs[id] && orgs[id].members.loading;
  }, false);
  var error = (0, _reduce["default"])(organisationIds).call(organisationIds, function (result, id) {
    return result || (orgs[id] ? orgs[id].members.error : false);
  }, false);
  return {
    loaded: loaded,
    loading: loading,
    error: error,
    entities: pick(state.entities, memberIds)
  };
}
function getMembersByIds(state, memberIds) {
  var entities = state.entities;
  var loaded = !!(0, _reduce["default"])(memberIds).call(memberIds, function (result, id) {
    return result || entities[id] && entities[id].loaded;
  }, false);
  var loading = !!(0, _reduce["default"])(memberIds).call(memberIds, function (result, id) {
    return result || entities[id] && entities[id].loading;
  }, false);
  var error = (0, _reduce["default"])(memberIds).call(memberIds, function (result, id) {
    return result || (entities[id] ? entities[id].error : false);
  }, false);
  return {
    loaded: loaded,
    loading: loading,
    error: error,
    entities: pick(state.entities, memberIds)
  };
}

/**
 * Indicate that members have been loaded.
 *
 * @param {Array} organisationIds The IDS of the orgs that members were loaded for.
 * @param {Object} members The members that were loaded.
 * @param {Array} memberIds The IDs of the members that were requested specifically.
 * @param {Boolean} orgsAreTeams Indicates is the organisationIds are actually for teams.
 * @param {Object} options Additional options
 * @param {Error|bool} error Any error that occurred during loading.
 *
 * @return {Object} The loaded members action.
 */
function loadedMembers(organisationIds, members, memberIds, orgsAreTeams, _temp) {
  if (orgsAreTeams === void 0) {
    orgsAreTeams = false;
  }
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error;
  return {
    type: LOADED_MEMBERS,
    organisationIds: organisationIds,
    members: members,
    memberIds: memberIds,
    orgsAreTeams: orgsAreTeams,
    error: error
  };
}

/**
 * Indicate that members are being loaded.
 *
 * @param {Array} organisationIds The IDS of the orgs that members were loaded for.
 * @param {Array} memberIds The IDs of the members that were requested specifically.
 *
 * @return {Object} The loading members action.
 */
function loadingMembers(organisationIds, memberIds) {
  return {
    type: LOADING_MEMBERS,
    organisationIds: organisationIds,
    memberIds: memberIds
  };
}

/**
 * Indicate that we need to clear up not loaded members.
 *
 * @param {Array} memberIds The IDs of the members that were requested specifically.
 *
 * @return {Object} The loading members action.
 */
function membersNotFoundPage(memberIds) {
  return {
    type: MEMBERS_NOT_FOUND,
    memberIds: memberIds
  };
}

/**
 * Load members for the given organisations.
 *
 * @param {Function} getMembers Function to load entity data with.
 * @param {Array} organisationIds The IDs of the organisation(s) the members
 *                                belong to.
 * @param {Array} memberIds The IDs of any members being explicitly loaded; this
 *                          allows their loading flags to be set correctly while
 *                          loading is in progress.
* @param {Boolean} orgsAreTeams Are the organisationIds passed in teamIds?
 */
function loadMembers(getMembers, organisationIds, memberIds, orgsAreTeams) {
  if (organisationIds === void 0) {
    organisationIds = [];
  }
  if (memberIds === void 0) {
    memberIds = [];
  }
  if (orgsAreTeams === void 0) {
    orgsAreTeams = false;
  }
  if (!(0, _isArray["default"])(organisationIds)) {
    throw new Error('organisationIds must be an Array.');
  }
  if (!(0, _isArray["default"])(memberIds)) {
    throw new Error('memberIds must be an Array.');
  }

  /**
   * @param {Function} store.dispatch.
   * @param {Function} store.getState.
   *
   * @return {Promise} should be used for error handling / composition
   */
  return function dispatchLoadMembers(dispatch, getState) {
    var _getMembers;
    var _getState = getState(),
      members = _getState.members,
      orgs = _getState.members.orgs;

    // Don't load members if everything is loaded or loading already
    var toLoadIds = (0, _filter["default"])(organisationIds).call(organisationIds, function (id) {
      return !orgs[id] || !(orgs[id].members.loaded || orgs[id].members.loading);
    });
    if (!toLoadIds.length) {
      var loadingIds = (0, _filter["default"])(organisationIds).call(organisationIds, function (id) {
        return orgs[id].members.loading;
      });
      // Flag not found members if nothing to load or loading
      if (memberIds.length && !loadingIds.length) dispatch(membersNotFoundPage(memberIds));
      return _promise["default"].resolve(getOrganisationMembers(members, organisationIds));
    }
    dispatch(loadingMembers(organisationIds, memberIds));
    var isTeamId = orgsAreTeams ? 'teamId' : 'organisationId';
    return getMembers((_getMembers = {}, _getMembers[isTeamId] = toLoadIds, _getMembers.typeCode = memberTypes, _getMembers)).then(function (data) {
      return dispatch(loadedMembers(organisationIds, data.results, memberIds, orgsAreTeams));
    })["catch"](function (error) {
      return dispatch(loadedMembers(organisationIds, [], memberIds, orgsAreTeams, {
        error: error
      }));
    }).then(function () {
      return getOrganisationMembers(getState().members, organisationIds);
    });
  };
}
function loadMembersByIds(getMembers, memberIds) {
  if (memberIds === void 0) {
    memberIds = [];
  }
  if (!(0, _isArray["default"])(memberIds)) {
    throw new Error('memberIds must be an Array.');
  }
  return function dispatchLoadMembersByIds(dispatch, getState) {
    var _getState2 = getState(),
      members = _getState2.members,
      entities = _getState2.members.entities;
    var toLoadIds = (0, _filter["default"])(memberIds).call(memberIds, function (id) {
      return !entities[id] || !(entities[id].loaded || entities[id].loading);
    });
    if (!toLoadIds.length) {
      var loadingIds = (0, _filter["default"])(memberIds).call(memberIds, function (id) {
        return entities[id].loading;
      });
      // Flag not found members if nothing to load or loading
      if (memberIds.length && !loadingIds.length) dispatch(membersNotFoundPage(memberIds));
      return _promise["default"].resolve(getMembersByIds(members, memberIds));
    }
    dispatch(loadingMembers([], memberIds));
    return getMembers({
      id: memberIds
    }).then(function (data) {
      return dispatch(loadedMembers([], data.results, memberIds));
    })["catch"](function (error) {
      return dispatch(loadedMembers([], [], memberIds, {
        error: error
      }));
    }).then(function () {
      return getMembersByIds(getState().members, memberIds);
    });
  };
}